import BaseObject from '../../../../base/base_object';
import Model from "./deep_link_model";
import {KEY_NAME} from "../../native/native_const";
import Event from "../../../../utils/event";
import {SYSTEM_EVENTS} from "../../../../events/events";

class DeepLinkHybrid extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'DeepLink';

    _model = null;
    _HybridService = null;

    init(params) {
        super.init(params);
        this._model = Model.create(params);
    }

    initFeatures(hybridSrv) {
        this._HybridService = hybridSrv;
        return this;
    }

    onHybridDirectCall(data) {
        this._model.updateData(data);

        const deepLinkObject = this._model.getDeepLinkObject();

        if(deepLinkObject && deepLinkObject[KEY_NAME.ACTION]) {
            Event.fire(SYSTEM_EVENTS.DEEPLINK_RECEIVED, deepLinkObject);
        }
    }
}
export default DeepLinkHybrid;
